<template>
    <div class="record-accident-documentation loading-content-container">
        <div v-if="isLoading" class="loading-overlay d-flex justify-content-center pt-5">
            <csp-loading-indicator/>
        </div>
        <div v-if="!isLoading">
            <b-row>
                <b-col>
                    <b-row>
                        <csp-desktop-accident-documentation-basedata
                            :form-context="initialFormContexts.accidentDocumentationBasedata"/>
                    </b-row>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import AccidentDocumentationBasedata
        from '@desktop/components/record/accident-documentation/AccidentDocumentationBasedata';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import FormContext from '@desktop/components/FormContext';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'RecordAccidentDocumentation',
        components: {
            'csp-desktop-accident-documentation-basedata': AccidentDocumentationBasedata,
        },
        mixins: [FormDataMixin],
        data() {
            const recordId = this.$route.params.recordId;
            return {
                recordId,
                initialFormContexts: {
                    accidentDocumentationBasedata: new FormContext({
                        name: 'accidentDocumentationBasedata',
                        objectId: recordId,
                        reloadFields: [],
                    }),
                },
                isLoading: true,
            };
        },
        created() {
            const loadFunction = () => {
                return recordRepository.loadAccidentDocumentation(this.recordId);
            }

            this.loadFormData(loadFunction).finally(() => {
                this.isLoading = false;
            });
        },
    }
</script>
